import { Component } from '@angular/core';

@Component({
  selector: 'app-trial-agreement',
  templateUrl: './trial-agreement.component.html',
  styleUrls: ['./trial-agreement.component.scss']
})
export class TrialAgreementComponent {}
